export default __webpack_public_path__ + "static/media/4982.eed61089.png";